import { useState, useEffect } from "react";

import { getSearchDate, SearchDateResponse } from "api/searchDate";

/**
 * 指定の日付をもとに締日の対象期間を取得する
 */
export const useSearchDate = (targetDate: string) => {
  const [searchDate, setSearchDate] = useState<SearchDateResponse>({
    id: "",
    fromDate: "",
    toDate: ""
  });
  useEffect(() => {
    if (!targetDate) return;

    getSearchDate({ targetDate }).then(res => {
      setSearchDate(res);
    });
  }, [targetDate]);
  return searchDate;
};

export default useSearchDate;
